import React, { type Dispatch, type SetStateAction } from 'react'
import classNames from 'classnames'
import { ColorTheme } from '@dustin-web/styledust/constants'
import CloseButton from '../close-button/close-button'
import ConditionalWrapper from '../utils/conditional-wrapper'

type CaseProps =
  | { closeable: boolean | true }
  | { closeable?: false; }

export type SharedProps = {
  children?: React.ReactNode
  fullWidth?: boolean
} & CaseProps

export type BannerProps = {
  color: ColorTheme
  border?: boolean
  className?: string
  onClose?: Dispatch<SetStateAction<boolean>>
} & SharedProps

export const Banner = ({
  fullWidth = false,
  onClose,
  border = true,
  closeable = true,
  className,
  color,
  children,
}: BannerProps) => {
  return (
    <>
      <ConditionalWrapper
        condition={fullWidth}
        wrapper={children => {
          return (
            <div>
              <div
                className={classNames('banner-full-width', {
                  'c-box--border': border && !fullWidth,
                  'c-box--border-fullWidth': fullWidth,
                  [`t-${color}`]: color,
                })}>
                {children}
              </div>
            </div>
          )
        }}>
        <div
          className={classNames('c-box-banner', 'c-box-banner--small', className, {
            container: fullWidth,
            'c-box': !fullWidth,
            'u-mb-16': !fullWidth,
            'c-box--border': border && !fullWidth,
            'c-box-banner--closable': closeable,
            [`t-${color}`]: color,
          })}>
          {children}
          {onClose && closeable && (
            <CloseButton className="close-btn" onClose={() => onClose(true)} small />
          )}
        </div>
      </ConditionalWrapper>
    </>
  )
}
